
import { getLanguageString } from "@/composables/translationText";

var languageInUse = "en"

const foreignLanguageToEnglishMap = new Map()

// accumulate all the foreign words to make sure they are valid for the recognizer
const completeWordMap = new Map()

const englishToForeignMap = new Map();
const phraseMap = new Map()

var noTranslationWordArray = []
var noTranslationPhraseArray = []

function isPunctuationChar(char) {
  const punctuationChars = [".", ",", ":", ";", "!", "?", "'", '"', "-", "(", ")", "[", "]", "{", "}"];
  return punctuationChars.includes(char);
}

export function translateForeignWords(string) {

  const words = string.split(" ")
  var outputWords = []
  for (var i = 0; i < words.length; i++) {
    const english = foreignLanguageToEnglishMap.get(words[i])
    if (english == null)
      outputWords.push(words[i])
    else {
      outputWords.push(english)
    }
  }
  const outputString = outputWords.join(" ")
  return (outputString)
}

export function translateEnglishWords(string,isWordList) {

  if (languageInUse == "en")
    return (string)

  // if a wordlist, then build the reverse map while here
  if (isWordList == true)
    foreignLanguageToEnglishMap.clear()

  const words = string.split(" ")
  var outputWords = []
  var outputWord = ""
  for (var i = 0; i < words.length; i++) {
    const word = words[i].toLowerCase()

    // find the english word
    const oneString = englishToForeignMap.get(word)

    // english word doesn't exist, convert to uppercase to flag it.
    if (oneString == null) {
      if (isPunctuationChar(oneString) == false)
        console.log("***** ENGLISH WORD NOT IN LIST -> ",word)
      outputWord = word.toUpperCase()
      outputWords.push(outputWord)

      // put something on the reverse map
      if (isWordList == true)
        foreignLanguageToEnglishMap.set(outputWord,word)

      // if a spoken word and on the development machine, save up all the spoken words
      if (isWordList && import.meta.env.MODE !== 'production')
        completeWordMap.set(outputWord,outputWord)
    }
    else {
        // the english word is mapped to the foreign language. send back the foreign equivalent
        
        // if the foreign language string has an embedded space (multiple words map)
        //.       for wordlist - use all multiple choices and map each word to the one english word
        //.       if not wordlist - use the first one

        if (oneString.includes(" ")) {
          const foreignWords = oneString.split(" ")
          if (isWordList == false)
            outputWords.push(foreignWords[0])
          else {
            for (var j=0; j < foreignWords.length; j++) {
              outputWords.push(foreignWords[j])
              foreignLanguageToEnglishMap.set(foreignWords[j],word)   
            }
            if (import.meta.env.MODE !== 'production')
              completeWordMap.set(word,word)
          }
        }
        else { 
          outputWords.push(oneString)

          // it's a spoken word, need to reverse map it to get the english back
          if (isWordList == true)
            foreignLanguageToEnglishMap.set(oneString,word)    

          if (isWordList && import.meta.env.MODE !== 'production')
            completeWordMap.set(word,word)
        }
    }
  }
  const outputString = outputWords.join(" ")

  if (import.meta.env.MODE !== 'production') {
    var keys = Array.from( completeWordMap.keys() )
    keys.sort()
    //console.log(JSON.stringify(keys, null, 1))
  }

  return (outputString)
}

export function translatePhrase(string) {
  if (languageInUse == "en")
    return (string)
  const oneString = phraseMap.get(string)
  if (oneString == null)
      return (string.toUpperCase())
  return (oneString)
}

export function setTranslationLanguage(language) {
  languageInUse = language

  const jsonArrays = getLanguageString()
  const rawJson = jsonArrays[0]
  const phraseJson = jsonArrays[1]

  englishToForeignMap.clear()
  phraseMap.clear()

  for (var i = 0; i < rawJson.length; i++) {
    const oneEntry = rawJson[i]
    if (oneEntry[language] == null) {
      console.log("********************************* no translation",language,oneEntry)
    }
    else
    englishToForeignMap.set(oneEntry.en,oneEntry[language].toLowerCase())
  }

  for (var i = 0; i < phraseJson.length; i++) {
    const oneEntry = phraseJson[i]
    phraseMap.set(oneEntry.en,oneEntry[language])
  }

  //console.log(englishToForeignMap)
  //console.log(phraseMap)

  // var stringArray = []
  // phraseMap.forEach((value, key) => {
  //   stringArray.push(key)
  // });
  // const jsonString = JSON.stringify(stringArray);
  // console.log(jsonString)
}



